import { render, staticRenderFns } from "./EditOrder.vue?vue&type=template&id=190464a5&scoped=true&"
import script from "./EditOrder.vue?vue&type=script&lang=js&"
export * from "./EditOrder.vue?vue&type=script&lang=js&"
import style0 from "./EditOrder.vue?vue&type=style&index=0&id=190464a5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190464a5",
  null
  
)

export default component.exports